import * as React from 'react';

import { LocalizedText } from 'bernie-l10n';

import { classNames } from 'uitk-react-utils';

interface GuestRoomScoreItemsProps {
  roomScoreCriteriaAndCount: string;
  isTextLocalized?: boolean;
  isBold?: boolean;
}

export const GuestRoomScoreItem: React.FunctionComponent<GuestRoomScoreItemsProps> = props => {
  const { roomScoreCriteriaAndCount, isTextLocalized, isBold } = props;

  if (!roomScoreCriteriaAndCount) {
    return null;
  }
  const guestRoomRatingItemText = isTextLocalized ? roomScoreCriteriaAndCount : <LocalizedText message={roomScoreCriteriaAndCount} />;

  const itemClass = classNames({
    'uitk-type-300 uitk-type-bold pwa-theme--grey-700 all-t-padding-one': isBold,
    'uitk-type-300 uitk-type-regular pwa-theme--grey-700 all-t-padding-two': !isBold,
  });

  return (
    <li className={itemClass} data-stid="room-score-rating-text">
      {guestRoomRatingItemText}
    </li>
  );
};
